module.exports = __webpack_public_path__ + "static/terra-mattress-5-311de091b97e4a5b8412c45016ba9426.webp";